import { useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";
import { useSelector } from "react-redux";
import { EditBox, AddToList, DeleteSvg, CloseSvg } from "../../icons/Icon";
import { LoadingSvg } from "../../icons/Icon";
import { Loading } from "../Loaders";
import InputWrapper from "../components/InputWrapper";
import { SelectOptionsSection } from "../../widgets/MultiSelectOptions";
import { SelectHtml } from "../../widgets/MultiSelectOptions";
import { useEventContext } from "../../contexts/EventContextProvider";
import { cancelEditEvent, updateTagsByVariantIdEvent } from "../../events/VariantEditorEvents";
import { iconsMap } from "../../icons/iconsMap";
import { $serializeForm } from "../../main";

const VariantTagToken = (p) => {
    return (
        <li key={`li-${p.item.id}`}
            className={`ExpandableTokens_token`}>
            <span>{p.item.name}</span><figure onClick={(e) => p.onDelete(e, p.item)}><CloseSvg /></figure>
        </li>
    );
}
const tokensToList = (tokens) => {
    return Object.keys(tokens).map(key => ({ id: key, name: tokens[key] }));
};
const VariantTagInputBar = forwardRef((p, r) => {

    const [tokens, setTokens] = useState({});
    const eventContext = useEventContext();
    const [state, setState] = useState({ tags: [], tagMap: {}, tagsOptions: [], tagGroupsOptions: [], selected: [] });
    const tags = useSelector((state) => state.base.tags);
    const tagGroups = useSelector((state) => state.base.tagGroups);
    const form = useRef(null);

    useImperativeHandle(r, () => ({
        getForm: () => form.current
    }));
    const icons = {
        loading: '',
        edit: <EditBox />,
        create: <AddToList />,
        delete: <DeleteSvg />,
    };
    const actionClass = {
        edit: 'CollectionInputBar_controls_edit',
        save: 'CollectionInputBar_controls_edit',
        create: 'CollectionInputBar_controls_create',
        delete: 'CollectionInputBar_controls_delete',
    };
    useEffect(() => {
        if (Array.isArray(tags)) {
            var tagsOptions = tags.map(tag => ({ value: `${tag.id}-${tag.name}`, label: tag.name }));
            var tagMap = tags.reduce((a, c) => {
                a[c.id] = c.name;
                return a;
            }, {});
        }
        if (Array.isArray(tagGroups)) {
            var tag_groups = tagGroups.map(tag => ({ value: `${tag.id}-${tag.name}`, label: tag.name }));
        }
        setState({ tags: tags, tagMap: tagMap, tagsOptions: tagsOptions, tagGroupsOptions: tag_groups, tagGroups: tagGroups });
    }, [tags, tagGroups]);
    useEffect(() => {
        /*if (p.payload && state.tagMap) {
            const tagIds = (p.payload.tags && p.payload.tags.split(',')) || [];
            //console.log('VariantTagInputBar.tags', tagIds, tagMap);
            if (Array.isArray(tagIds)) {
                const tokens = tagIds.reduce((a, c) => {
                    a[c] = state.tagMap[c];
                    return a;
                }, {});
                //console.log('VariantTagInputBar.tokens', tokens);
                setTokens(tokens);
            }
        }*/
        let tags = eventContext?.state?.variantTagCRUD?.payload?.tags;
        if (Array.isArray(tags)) {
            setTokens(tags.reduce((accumulator, tag) => {
                accumulator[tag.id] = tag.name;
                return accumulator;
            }, {}));
        }
    }, [eventContext?.state?.variantTagCRUD]);
    const onTagSelectChange = (e) => {
        console.log('onTagSelectChange', e);

        if (Array.isArray(e) && e.length > 0) {
            let found = e.map(tag => {
                return { id: tag.value.split('-')[0], name: tag.label };
            }).reduce((accumulator, current) => {
                accumulator[current.id] = current.name;
                return accumulator;
            }, {});
            setTokens(previous => ({ ...previous, ...found }));
        }
    }
    const onTagGroupSelectChange = (e) => {
        //console.log('onTagGroupSelectChange.e', e);
        if (Array.isArray(e)) {
            let found = e.map(group => {
                let tagGroup = group.value.split('-');
                return { id: tagGroup[0], name: tagGroup[1] };
            }).map(selected => {
                return state.tagGroups.find(group => group.id == selected.id);
            }).flatMap(found => found.tags)
                .reduce((accumulator, current) => {
                    accumulator[current.id] = current.name;
                    return accumulator;
                }, {});
            //console.log('onTagGroupSelectChange.f', found);
            setTokens(previous => ({ ...previous, ...found }));
        }
    }
    const onDelete = (e, o) => {
        e.preventDefault();
        let filtered = Object.keys(tokens)
            .filter(key => key != o.id)
            .reduce((a, c) => {
                a[c] = tokens[c];
                return a;
            }, {});
        setTokens(filtered);
    };
    const renderList = (list) => {
        return (
            (Array.isArray(list)) ?
                <div className="ExpandableTokens">
                    <div className="ExpandableTokens_slot">
                        <ul>
                            {(list.length > 0) && list.map((item, index) => {
                                return (
                                    <VariantTagToken key={`li-${item.id}`} item={item} onDelete={(e) => onDelete(e, item)} />
                                )
                            })}
                        </ul>
                    </div>
                    <SelectHtml
                        name={'tagsSelected[]'}
                        options={list ? list.map(item => ({ value: item.id, label: item.name })) : []}
                        selected={list ? list.map(item => ({ value: item.id, label: item.name })) : []}
                        multiple={true}
                        style={{ display: 'none' }} />
                </div> : <></>
        );
    }
    const onCancel = () => {
        eventContext.eventDispatch(cancelEditEvent());
    };
    const onSave = (m, id) => {
        const [encoded, json] = $serializeForm(form.current);
        updateTagsByVariantIdEvent(form, id);
    };
    const render = (p, m) => (
        <div className="CollectionInputBar">
            <div className="CollectionInputBar_header">
                <h6 className="CollectionInputBar_title">
                    {iconsMap[m?.type]}<span>{m?.title || ''}</span>
                    <em>{p?.name || ''}</em>
                </h6>
                <div className="CollectionInputBar_controls">
                    <button onClick={onCancel} className="CollectionInputBar_controls_cancel">cancel</button>
                    {(m?.button) ?
                        <button onClick={() => onSave(m, p?.id)} className={actionClass[m?.type]} >{m?.button}</button> :
                        <></>}
                </div>
            </div>
            <form ref={form}>
                <div className="CollectionInputBar_body">
                    <div className="flex-column">
                        <div className="flex-row">
                            <input type="hidden" name="id" value={p?.id || ''} />
                            <div className="col-12">
                                <InputWrapper label={'selected tags'}>
                                    <SelectOptionsSection
                                        name='tags[]'
                                        multiple={true}
                                        options={state.tagsOptions}
                                        selected={state.selected}
                                        onChange={onTagSelectChange}
                                        className={''}
                                    />
                                </InputWrapper>
                            </div>
                            <div className="col-12">
                                <InputWrapper label={'selected tag groups'}>
                                    <SelectOptionsSection
                                        name='tagGroups[]'
                                        multiple={true}
                                        options={state.tagGroupsOptions}
                                        selected={state.selected}
                                        onChange={onTagGroupSelectChange}
                                        className={''}
                                    />
                                </InputWrapper>
                            </div>
                        </div>
                        <div className="flex-row">
                            <div className="col-24">
                                <InputWrapper label={'Aggregate tags'}>
                                    {renderList(tokensToList(tokens))}
                                </InputWrapper>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );

    const renderCase = (state, render) => {
        switch (state?.status) {
            case 'LOADING':
                return <Loading><LoadingSvg /></Loading>;
            case 'DONE':
                return render(state.payload, state.meta);
            case 'ERROR':
                return <></>;
            default:
                return <></>;
        }
    }

    return renderCase(eventContext?.state?.variantTagCRUD, render);
});

export default VariantTagInputBar;
